(() => {
  class PhantomProduct extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === "true") return;
      this.dataset.ready = "true";

      this.mainImage = this.querySelector(".phantom-product__main-image");
      this.zoomDialog = this.querySelector("[data-phantom-zoom]");
      this.zoomImage = this.querySelector("[data-phantom-zoom-image]");

      this.querySelectorAll("[data-phantom-thumbnail]").forEach((button) => {
        button.addEventListener("click", () => this.selectMedia(button));
      });

      this.querySelector("[data-phantom-zoom-trigger]")?.addEventListener("click", () => {
        if (!this.zoomDialog || !this.zoomImage || !this.mainImage) return;
        this.zoomImage.src = this.mainImage.currentSrc || this.mainImage.src;
        this.zoomImage.alt = this.mainImage.alt;
        if (typeof this.zoomDialog.showModal === "function") this.zoomDialog.showModal();
      });

      this.querySelector("[data-phantom-zoom-close]")?.addEventListener("click", () => {
        this.zoomDialog?.close();
      });

      this.zoomDialog?.addEventListener("click", (event) => {
        if (event.target === this.zoomDialog) this.zoomDialog.close();
      });

      this.variantSelect = this.querySelector("[data-phantom-variant-select]");
      this.variantSelect?.addEventListener("change", () => this.updateVariant());
    }

    selectMedia(button) {
      if (!this.mainImage) return;
      const { fullSrc, alt } = button.dataset;
      if (!fullSrc) return;

      this.mainImage.srcset = "";
      this.mainImage.src = fullSrc;
      this.mainImage.alt = alt || "";

      this.querySelectorAll("[data-phantom-thumbnail]").forEach((thumbnail) => {
        thumbnail.setAttribute("aria-current", thumbnail === button ? "true" : "false");
      });
    }

    updateVariant() {
      const option = this.variantSelect?.selectedOptions?.[0];
      if (!option) return;

      const price = this.querySelector("[data-phantom-price]");
      const sku = this.querySelector("[data-phantom-sku]");
      const addButton = this.querySelector("[data-phantom-add-button]");
      const available = option.dataset.available === "true";

      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (sku) sku.textContent = option.dataset.sku || sku.dataset.fallback || "Made to order";

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available
          ? addButton.dataset.availableLabel
          : addButton.dataset.soldOutLabel;
      }
    }
  }

  if (!customElements.get("phantom-product")) {
    customElements.define("phantom-product", PhantomProduct);
  }
})();
